import React, { forwardRef } from 'react'
import { SvgIcon, useTheme } from '@mui/material'

/**
 * The CircleWarningIcon's component.
 */
const CircleWarningIcon = forwardRef((props, ref) => {
  const { palette } = useTheme()

  return (
    <SvgIcon
      {...props}
      height="64px"
      ref={ref}
      version="1.1"
      viewBox="0 0 64 64"
      width="64px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-0.500000, 0.000000)">
          <circle cx="32" cy="32" fill={palette.yellow[90]} r="32" />
          <g fill={palette.brand.warning} transform="translate(13.000000, 13.000000)">
            <path d="M34.251943,29.1096277 L21.0534521,7.22464375 C20.719891,6.67154016 20.1209851,6.33333333 19.4749565,6.33333333 C18.8289279,6.33333333 18.2300221,6.67148142 17.896461,7.22464375 L4.69808757,29.1096277 C4.35483162,29.678828 4.34466673,30.3887862 4.67158835,30.9675035 C4.99850997,31.5462796 5.61175241,31.9041667 6.27652437,31.9041667 L32.6734475,31.9041667 C33.3382194,31.9041667 33.9514619,31.5462208 34.2783835,30.9675035 C34.6053051,30.3887275 34.595199,29.678828 34.251943,29.1096277 Z M19.4853178,13.8541667 C20.2944938,13.8541667 20.9791667,14.3048752 20.9791667,15.1037404 C20.9791667,17.5413938 20.6887013,21.0443866 20.6887013,23.48204 C20.6887013,24.1171069 19.9832674,24.3833333 19.4853178,24.3833333 C18.8214685,24.3833333 18.261236,24.1170449 18.261236,23.48204 C18.261236,21.0443866 17.9708333,17.5413938 17.9708333,15.1037404 C17.9708333,14.3048752 18.6346826,13.8541667 19.4853178,13.8541667 Z M19.4848374,28.8958333 C18.6197432,28.8958333 17.9708333,28.1925896 17.9708333,27.3916667 C17.9708333,26.571196 18.6196837,25.8875 19.4848374,25.8875 C20.2909668,25.8875 20.9791667,26.571196 20.9791667,27.3916667 C20.9791667,28.1925896 20.2909668,28.8958333 19.4848374,28.8958333 Z" />
          </g>
        </g>
      </g>
    </SvgIcon>
  )
})

export default CircleWarningIcon
